import * as ActionCable from '@rails/actioncable'
import config from './config'

ActionCable.logger.enabled = import.meta.env.VITE_ENV !== 'production'

const consumer = ActionCable.createConsumer(config.actionCable.networkInterface)

export default consumer
